export var detailsBtn = {
  padding: '0.6em',
  '& > i': {
    margin: 0
  }
};
export var statusText = function statusText(colorKey) {
  return function (theme) {
    var _theme$colorKey;

    return {
      color: (_theme$colorKey = theme[colorKey]) !== null && _theme$colorKey !== void 0 ? _theme$colorKey : colorKey
    };
  };
};